import { render, staticRenderFns } from "./page-list-container.vue?vue&type=template&id=49626919&scoped=true"
import script from "./page-list-container.vue?vue&type=script&lang=js"
export * from "./page-list-container.vue?vue&type=script&lang=js"
import style0 from "./page-list-container.vue?vue&type=style&index=0&id=49626919&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49626919",
  null
  
)

export default component.exports